// @flow
import React, { useContext } from 'react';
import { useFormikContext } from 'formik';
import { usePreviousContractDetails } from '@src/custom-hooks/usePreviousContractDetails';

import { NegativeMessageContainer } from '../presentational/messages/NegativeMessageContainer';
import { IS_RENEWAL_AUTOMATION_LIVE } from '../../constants';
import { EstimateContext } from '../../contexts/EstimateContext';
import { useIsEstimateRenewal } from '../../custom-hooks/useIsEstimateRenewal';
import { useEstimateACVAfterDiscount } from '../../custom-hooks/useEstimateACVAfterDiscount';
import { If } from '../presentational/If';

import {
  getIfCustomDiscountsOrGlobalDiscountIsImported,
  getRenewalDiscountValidationWarningMessage,
} from './utils';

export const RenewalDiscountValidationWarningContainer = () => {
  const { values } = useFormikContext();
  const estimate = useContext(EstimateContext);
  const isEstimateRenewal = useIsEstimateRenewal();
  const estimateACV = useEstimateACVAfterDiscount();
  const { acv: previousContractACV, arr: previousContractARR } = usePreviousContractDetails();
  const hasImportedDiscounts = getIfCustomDiscountsOrGlobalDiscountIsImported(values, estimate);

  const warningMessage = getRenewalDiscountValidationWarningMessage({
    estimateACV,
    previousContractACV,
    previousContractARR,
  });

  const shouldShowWarningBanner =
    IS_RENEWAL_AUTOMATION_LIVE && isEstimateRenewal && hasImportedDiscounts && warningMessage;

  return (
    <If test={shouldShowWarningBanner}>
      <NegativeMessageContainer compact={true} header={warningMessage} />
    </If>
  );
};
